import { createApp } from 'vue';
import App from './App.vue';
import '@/assets/css/reset.css';

createApp(App).mount('#app');
